// Actions for touch devices with screen less then 1200px
$(document).ready(function(){
  function is_touch_device() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }

  if(is_touch_device() && window.innerWidth < 1200){
    $('.ci-account').remove();
    $('#sign-in-button').remove();
  }
});